// extracted by mini-css-extract-plugin
export default {"button":"styles_button__C3brN","backButton":"styles_backButton__IQpcW"};